import { required, numeric, integer, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    item: {
      inventory_id: {
        required: helpers.withMessage(i18n.global.t('Please select an ingredient.'), required)
      },
      inventory_lot_id: {
      },
      quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), required),
        minValue: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('quantity must be at least') +  ' ' + $params.min,
          minValue((formState.inventory_lot_id !== '')? -Math.abs(formState.remaining_quantity): 0.0001)
        ),
      },
      unit_id: {
        required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      cost: {
        required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
      },
      total_cost: {
        required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
      },
      reason_detail: {
      }
    }
  }
};
